import { render } from "./BasicForm.vue?vue&type=template&id=4a859599"
import script from "./BasicForm.vue?vue&type=script&lang=js"
export * from "./BasicForm.vue?vue&type=script&lang=js"
script.render = render

export default script